import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import ContactForm from "../ContactForm/ContactFormModal.js";

function Footer() {
    const [showContactForm, setShowContactForm] = useState(false);
    const location = useLocation();
    const isUSAFormationPage = location.pathname === '/usa-company-formation';
    const isTaxReturnPage = location.pathname === '/tax-return';
    const isBookkeepingPage = location.pathname === '/bookkeeping';
    const isCFOPage = location.pathname === '/cfo-advisory';
    const isZohoPage = location.pathname === '/zoho-advisory';

    const handleGetStartedClick = (e) => {
        e.preventDefault();
        setShowContactForm(true);
    };

    const handleCloseContactForm = () => {
        setShowContactForm(false);
    };

    return (
        <div className="relative pt-[120px]">
            {/* Free Consultation Section - Enhanced Design */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 -mb-[120px]">
                <div className="flex justify-center">
                    <div className="w-full lg:w-11/12">
                        <div className="bg-white p-6 md:p-10 rounded-t-3xl border-t-[12px] border-t-[#0d6efd] relative -mt-[100px] mb-[50px] shadow-[0_20px_50px_rgba(0,0,0,0.12)] backdrop-blur-sm">
                            {/* Decorative gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-br from-[#f8fbff] via-white to-[#e0f2ff] rounded-t-3xl opacity-50"></div>

                            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
                                <div className="text-center md:text-left mb-6 md:mb-0 md:pr-8">
                                    <h3 className="mb-0 text-[1.15rem] leading-snug font-bold text-[#1a202c] md:text-[1.5rem]">
                                        {isUSAFormationPage
                                            ? 'Ready to start your U.S. company? Let BooksComply handle formation, EIN, and compliance — while you focus on growth.'
                                            : isTaxReturnPage
                                                ? 'Ready to file your U.S. tax return the smart way? Let BooksComply handle your preparation, filing, and compliance — all in one place.'
                                                : isBookkeepingPage
                                                    ? 'Ready to simplify your bookkeeping and focus on growing your business? Let BooksComply handle your accounts — from daily entries to year-end reporting.'
                                                    : isCFOPage
                                                        ? 'Ready to level up your financial strategy? Hire a Virtual CFO in the USA to manage your cash flow, forecasting, and growth planning.'
                                                        : isZohoPage
                                                            ? 'Ready to set up Zoho Books, Payroll, or Inventory? Get expert implementation, migration, and training designed for U.S. businesses.'
                                                            : 'Ready to simplify your U.S. bookkeeping and tax compliance?'}
                                    </h3>
                                </div>
                                <div className="flex-shrink-0">
                                    <button
                                        onClick={handleGetStartedClick}
                                        className="group relative font-semibold rounded-full py-4 px-10 bg-gradient-to-r from-[#ff6b00] to-[#e65c00] text-white shadow-[0_8px_25px_rgba(255,107,0,0.35)] whitespace-nowrap transition-all duration-300 hover:shadow-[0_12px_35px_rgba(255,107,0,0.45)] hover:scale-105 overflow-hidden"
                                    >
                                        <span className="relative z-10 flex items-center gap-2">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                            Book a free consultation
                                        </span>
                                        <div className="absolute inset-0 bg-gradient-to-r from-[#e65c00] to-[#ff6b00] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer - Enhanced Design */}
            <footer className="bg-gradient-to-br from-[#007bff] via-[#0056b3] to-[#012f61] text-white pt-[150px] pb-8 relative z-[1] mt-0 animate-fadeIn">

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                        {/* Contact Info with Logo and Description - Enhanced */}
                        <div className="mb-6 text-left">
                            <div className="flex items-center mb-4">
                                <div className="relative group">
                                    <a href="/" className="mr-4 block">
                                        <div className="w-14 h-14 bg-white rounded-2xl p-2 shadow-lg transition-all duration-300 group-hover:shadow-xl group-hover:scale-105">
                                            <img
                                                src="/logo192.png"
                                                alt="BooksComply Logo"
                                                className="w-full h-full object-contain"
                                                width="40"
                                                height="40"
                                                loading="lazy"
                                            />
                                        </div>
                                    </a>
                                </div>
                                <div>
                                    <h2 className="mb-1 text-2xl font-bold">
                                        <a href="/" className="text-white no-underline hover:text-[#95dde4] transition-colors duration-300 flex items-center gap-2">
                                            BooksComply
                                            <span className="w-2 h-2 bg-[#95dde4] rounded-full animate-pulse"></span>
                                        </a>
                                    </h2>
                                    <a href="mailto:contact@BooksComply.com" className="text-white/80 hover:text-[#95dde4] transition-colors duration-300 text-sm flex items-center gap-1 no-underline">
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                        contact@BooksComply.com
                                    </a>
                                </div>
                            </div>
                            <p className="text-white/70 text-sm mb-0 leading-relaxed max-w-[320px]">
                                Simplifying U.S. bookkeeping, tax filing, and company formation for startups and small businesses worldwide.
                            </p>

                            {/* Contact buttons */}
                            <div className="mt-4 flex flex-col gap-2"></div>
                        </div>

                        {/* Services - Enhanced */}
                        <div className="mb-6 text-left">
                            <div className="flex items-center gap-2 mb-6">
                                <div className="w-8 h-8 bg-[#95dde4]/20 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#95dde4]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                    </svg>
                                </div>
                                <h6 className="font-bold text-lg uppercase tracking-wider">SERVICES</h6>
                            </div>
                            <ul className="list-none p-0 m-0 space-y-3">
                                <li><a href="/bookkeeping" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Bookkeeping
                                </a></li>
                                <li><a href="/cfo-advisory" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    CFO Advisory
                                </a></li>
                                <li><a href="/tax-return" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Tax Return
                                </a></li>
                                <li><a href="/usa-company-formation" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    USA Company Formation
                                </a></li>
                                <li><a href="/zoho-advisory" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Zoho Advisory
                                </a></li>
                            </ul>
                        </div>

                        {/* Resources - Enhanced */}
                        <div className="mb-6 text-left">
                            <div className="flex items-center gap-2 mb-6">
                                <div className="w-8 h-8 bg-[#95dde4]/20 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#95dde4]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                    </svg>
                                </div>
                                <h6 className="font-bold text-lg uppercase tracking-wider">RESOURCES</h6>
                            </div>
                            <ul className="list-none p-0 m-0 space-y-3">
                                <li><a href="/blog" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Blog
                                </a></li>
                                <li><a href="/events/zoho-books-ahmedabad" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Events
                                </a></li>
                                <li><a href="/help" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Help Center
                                </a></li>
                                <li><a href="/why-bookscomply" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Why BooksComply
                                </a></li>
                            </ul>
                        </div>

                        {/* Legal - Enhanced */}
                        <div className="mb-6 text-left">
                            <div className="flex items-center gap-2 mb-6">
                                <div className="w-8 h-8 bg-[#95dde4]/20 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#95dde4]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                    </svg>
                                </div>
                                <h6 className="font-bold text-lg uppercase tracking-wider">LEGAL</h6>
                            </div>
                            <ul className="list-none p-0 m-0 space-y-3">
                                <li><a href="/privacy-policy" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Privacy Policy
                                </a></li>
                                <li><a href="/subscription-agreement" className="text-white/80 hover:text-[#95dde4] transition-all duration-300 no-underline flex items-center gap-2 group">
                                    <span className="w-1.5 h-1.5 bg-[#95dde4] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                    Subscription Agreement
                                </a></li>
                            </ul>
                        </div>
                    </div>

                    {/* Social Media Icons - Enhanced */}
                    <div className="mt-10">
                        <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
                            <div className="flex items-center gap-2">
                                <span className="text-white/60 text-sm uppercase tracking-wider">Follow Us</span>
                                <div className="flex gap-3">
                                    <a href="https://www.linkedin.com/company/njpglobal/" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center w-10 h-10 bg-white/10 hover:bg-[#95dde4] rounded-full transition-all duration-300 hover:scale-110">
                                        <FaLinkedin className="text-white group-hover:text-[#012f61]" size={18} />
                                    </a>
                                    <a href="https://x.com/NJP_Advisors/" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center w-10 h-10 bg-white/10 hover:bg-[#95dde4] rounded-full transition-all duration-300 hover:scale-110">
                                        <FaTwitter className="text-white group-hover:text-[#012f61]" size={18} />
                                    </a>
                                    <a href="https://www.instagram.com/bookscomply/" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center w-10 h-10 bg-white/10 hover:bg-[#95dde4] rounded-full transition-all duration-300 hover:scale-110">
                                        <FaInstagram className="text-white group-hover:text-[#012f61]" size={18} />
                                    </a>
                                </div>
                            </div>

                            {/* Newsletter Signup */}
                            <div></div>
                        </div>
                    </div>

                    {/* Copyright - Enhanced */}
                    <div className="mt-8 pt-6 border-t border-white/20">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <p className="text-white/60 text-sm mb-0">
                                &copy; {new Date().getFullYear()} NJP Global Services Pvt. Ltd. All Rights Reserved.
                            </p>
                            <div className="flex items-center gap-4 text-white/60 text-sm">
                                <span>Powered by</span>
                                <span className="text-[#95dde4] font-semibold">BooksComply</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {showContactForm && <ContactForm onClose={handleCloseContactForm} />}
        </div>
    );
}

export default Footer;